var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"warning",attrs:{"border":"left","colored-border":"","icon":"mdi-alert-rhombus"}},[_vm._v(" Leaving now will discard all unsaved changes to the current profile. ")])}
var staticRenderFns = []

export { render, staticRenderFns }